import React, { useEffect } from 'react'
import { useTable, useRowSelect, useFilters, usePagination, useGlobalFilter } from 'react-table'
import FirstPageIcon from '../images/pagination-left.png'
import KeyboardArrowLeft from '../images/arrow-left-b.png'
import KeyboardArrowRight from '../images/arrow-right-b.png'
import LastPageIcon from '../images/pagination-right.png'
import matchSorter from 'match-sorter'
import ReactLoading from 'react-loading';

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef()
    const resolvedRef = ref || defaultRef
    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate])
    return (
      <>
        <label className={rest.checked ? 'checkbox_active':'checkbox'}>
          <input type="checkbox" ref={resolvedRef} {...rest} />
        </label>
      </>
    )
  }
)

function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length

  return (
    <input
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined)
      }}
      placeholder={`Search ${count} records...`}
    />
  )
}

const memberListFilterFn = (rows, id, filterValue) => {
  return matchSorter(rows, filterValue, { keys: [
    row => row.values['title'],
    row => row.values['birthday'],
    row => row.values['phone'],
  ]})
}
memberListFilterFn.autoRemove = val => !val

function Table({ columns, onPageChange, nowPage, loading, data, onRowClick, searchBar, globalFilterCoulmns}) {
  const defaultColumn = React.useMemo(
    () => ({
      Filter: DefaultColumnFilter,
    }),
    []
  )
  
  const filterTypes = React.useMemo(
    () => ({
      memberList: memberListFilterFn,
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true
        })
      },
    }),
    []
  )
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    pageOptions,
    pageCount,
    gotoPage,
    setGlobalFilter,
    state: { pageIndex, selectedRowIds },
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      filterTypes,
      globalFilter: globalFilterCoulmns && globalFilterCoulmns 
    },
    useFilters,
    useGlobalFilter,
    usePagination,
    useRowSelect,
    hooks => {
      hooks.visibleColumns.push(columns => [
        {
          id: 'selection',
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div style={{textAlign: 'center'}}>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ])
    }
  )
  useEffect(()=>{
    if (page.length > 0 ){
      gotoPage(nowPage)
    }
  }, [page, gotoPage, nowPage])
  return (
    <>
    {searchBar && searchBar(setGlobalFilter, selectedRowIds)}
    <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()} className="header">
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {loading ? 
          <tr>
            <td colSpan={headerGroups[0].headers.length}>
              <ReactLoading className="table-loading" type={'spokes'} color={'#ddd'} />
            </td>
          </tr>
          :page.length > 0 ?
            page.map((row, i) => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    const {id, className} = cell.column;
                    return <td className={className} onClick={() => id !== 'selection' && onRowClick(row)} {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  })}
                </tr>
              )
            }):<tr>
              <td colSpan={headerGroups[0].headers.length}>데이터 없음</td>
            </tr>
          }
        </tbody>
      </table>
    <div className="paging">
        <img src={FirstPageIcon} alt="FirstPageIcon" onClick={() =>  nowPage !== undefined ?onPageChange(0): gotoPage(0)}></img>
        <img src={KeyboardArrowLeft} alt="KeyboardArrowLeft" onClick={() =>  nowPage !== undefined ? onPageChange(pageIndex-1): gotoPage(pageIndex-1)}></img>
        {Array.from(
          { length: 5 },
          (v, i) => {
            return i + 1 + (Math.floor((pageIndex)/5)*5)
          }
        ).map(page => {
          return (
            page <= pageOptions.length &&
            <button
              key={page}
              className={pageIndex+1 === page ? 'select' : null}
              disabled={pageIndex+1 === page}
              onClick={() => nowPage !== undefined ? onPageChange(page-1) : gotoPage(page-1)}
            >
              {page}
            </button>
          );
        })
        }
        <img src={KeyboardArrowRight} alt="KeyboardArrowRight" onClick={() => nowPage !== undefined ? onPageChange(pageIndex+1):gotoPage(pageIndex+1)}></img>
        <img src={LastPageIcon} alt="LastPageIcon" onClick={() => nowPage !== undefined? onPageChange(pageCount - 1):gotoPage(pageCount - 1)}></img>
      </div>
    </>  
  )
}

function App({nowPage, onPageChange, columns, loading, data, searchBar, globalFilterCoulmns, onRowClick}) {
  return (
    <Table
      nowPage={nowPage}
      columns={columns}
      data={data}
      loading={loading}
      searchBar= {searchBar}
      globalFilterCoulmns={globalFilterCoulmns}
      onRowClick={onRowClick}      
      onPageChange={onPageChange}
    />
  )
}

export default App
